import axios from '@/plugins/axios'

/** link para o irmão definir a senha: convite de primeiro acesso ou reinício de senha */
class ConviteService {
	route = '/convites'

	async enviar(idIrmao: string) {
		await axios.post(this.route, { irmao: idIrmao })
	}
}

export default new ConviteService()
